/** @format */

import React from "react";
import "../../styles/centralised-plan/layouts.css";

const Tabs = ({
  activeTab,
  setActiveTab,
  tabs,
  customClasss,
  type = "primary",
}) => {
  if (type === "secondary") {
    return (
      <div
        className={`card-k flex-container p-2 rounded-3 tabsContainer ${
          customClasss || "general"
        }`}
      >
        {tabs.map((tab, index) => (
          <div
            key={tab}
            onClick={() => setActiveTab(tabs[index])}
            className={`tab-k secondary transition-bg-k transition-clr-k ${
              activeTab === tabs[index] ? "active-secondary" : ""
            }`}
          >
            <span>{tab}</span>
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className="flex-container gap-1-k">
      {tabs.map((tab, index) => (
        <div
          key={tab}
          onClick={() => setActiveTab(tabs[index])}
          className={`tab-k transition-bg-k transition-clr-k ${
            activeTab === tabs[index] ? "active" : ""
          }`}
        >
          <span>{tab}</span>
        </div>
      ))}
    </div>
  );
};

export default Tabs;
